import _ from "lodash";
import { REHYDRATE } from "redux-persist/constants";
import {
    GET_LEARNERS,
    ADD_LEARNERS,
    DELETE_LEARNER,
    MODIFY_LEARNER
} from "./LearnerManager.action.react";

const initialLearnersState = [];

const LearnerManagerReducer = (state = initialLearnersState, action) => {
    let enrolments;
    switch (action.type) {
        /* istanbul ignore next - react-persist function */
        case REHYDRATE:
            enrolments = action.payload.enrolments;
            if (enrolments) {
                return [...state, ...enrolments];
            } else {
                return state;
            }
        case GET_LEARNERS:
            return action.data;
        case ADD_LEARNERS:
            enrolments = _.cloneDeep(state);
            if (action.data !== null) {
                enrolments.push(action.data.learners);
            }
            return _.flatten(enrolments);
        case MODIFY_LEARNER:
            enrolments = _.cloneDeep(state);
            let targetLearner = _.find(enrolments, { id: action.data.id });
            targetLearner.cohort_tags = action.data.tags;
            return enrolments;
        case DELETE_LEARNER:
            enrolments = _.cloneDeep(state);
            _.remove(enrolments, {
                id: action.data.id
            });
            return enrolments;
        default:
            return state;
    }
};

export { LearnerManagerReducer };
